import axios from '@dap/shared-utils/http.js';

export default {
    getIncomeList: (params) => axios.get('/dapper/api/finance-v2/gxt_finance/income', { params }),
    getOutcomeList: (params) => axios.get('/dapper/api/finance-v2/gxt_finance/outcome', { params }),
    getDict: (_) => axios.get('/dapper/api/finance-v2/gxt_finance/dict'),
    getProgress: (params) =>
        axios.get('/dapper/api/finance-v2/gxt_finance/extraction_progress', {
            params,
        }),
    cancelProgress: (params) => axios.post('/dapper/api/finance-v2/gxt_finance/cancel_extraction', params),
    getRefundTrend: (params) =>
        axios.get('/dapper/api/finance-v2/gxt_finance/refund_trend', {
            params,
        }),
    getRefundDetail: (params) =>
        axios.get('/dapper/api/finance-v2/gxt_finance/refund_detail', {
            params,
        }),
    confirmIncome: (params) => axios.post('/dapper/api/finance-v2/gxt_finance/confirm_income_row', params),
    confirmOutcome: (params) => axios.post('/dapper/api/finance-v2/gxt_finance/confirm_outcome_row', params),
    getIncomeDetail: (params) =>
        axios.get('/dapper/api/finance-v2/gxt_finance/income_detail', {
            params,
        }),
    getOutcomeDetail: (params) =>
        axios.get('/dapper/api/finance-v2/gxt_finance/outcome_detail', {
            params,
        }),
    getUploadTemplate: (params) =>
        axios.get('/dapper/api/finance-v2/gxt_finance/upload_template', {
            params,
        }),
    editIncomeDetailNote: (params) => axios.post('/dapper/api/finance-v2/gxt_finance/income_detail_note', params),
    editOutcomeDetailNote: (params) => axios.post('/dapper/api/finance-v2/gxt_finance/outcome_detail_note', params),
    getIncomeLog: (params) => axios.get('/dapper/api/finance-v2/gxt_finance/income_log', { params }),
    getOutcomeLog: (params) => axios.get('/dapper/api/finance-v2/gxt_finance/outcome_log', { params }),
    getCanConfirmMonth: (params) =>
        axios.get('/dapper/api/finance-v2/gxt_finance/confirm_month', {
            params,
        }),
    confirmMonth: (params) => axios.post('/dapper/api/finance-v2/gxt_finance/confirm_month', params),

    //收入编辑
    postEditData (params = {}) {
        return axios.post('/dapper/api/fin/comes/edit', params);
    },
    //获取日志
    getLogData (params = {}) {
        return axios.get('/dapper/api/fin/comes/log', { params });
    },
    //查询当前未确认的批次列表
    postUnconfirmedData (params = {}) {
        return axios.post('/dapper/api/fin/comes/unconfirmed', params);
    },
    //查询当前未确认的批次列表
    postMonthVerify (params = {}) {
        return axios.post('/dapper/api/fin/comes/month_verify', params);
    },
    //确认是否已阅读
    getIsConfirm (params = {}) {
        return axios.get('/dapper/api/fin/comes/month_1591083402341', {
            params,
        });
    },
    //确实该月份是否已确认
    checkUpload (params = {}) {
        return axios.get('/dapper/api/fin/check/total_status', { params });
    },
    //获取 Ua_group
    getgxt_ua_group (params = {}) {
        return axios.get('/dapper/api/finance-v2/gxt_finance/ua_group', {
            params,
        });
    },

    // 下载回款账单
    getBilling (params = {}) {
      return axios.get('/dapper/api/finance-v2/gxt_finance/bill_repayment', {
          params,
      });
    },

    // 回款录入
    collectionEntry (params = {}) {
        return axios.post('/dapper/api/finance-v2/gxt_finance/bill_repayment', params, {
            headers: { 'Content-Type': 'application/json' },
        });
    },

    // 回款录入
    deleteBilling (params = {}) {
        return axios.delete('/dapper/api/finance-v2/gxt_finance/bill_repayment', { params });
    },

    // 确认全部回款
    sureBilling (params = {}) {
        return axios.post('/dapper/api/finance-v2/gxt_finance/bill_repayment_confirm',  params, {
          headers: { 'Content-Type': 'application/json' },
      });
    },
};
